<template>
    <div class="mx_content">
        <div class="mx_title">
            <div class="title_left">
                <span>业绩资料</span>
            </div>
            <div class="title_right">
                <el-button v-if="canEdit && baseModule === 'zljysq'" size="mini" @click="xbzbYjzlAdd">添加</el-button>
                <el-button size="mini" @click="xbzbYjzlExport">导出</el-button>
            </div>
        </div>
        <el-table :data="listData" style="width: 100%" @row-click="cellclick" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="projectName" label="项目名称" align="center">
                <!-- <template slot-scope="scope"> -->
                <!-- <div v-if="vo.status <= 1">{{ scope.row.projectName }}</div> -->
                <!-- <div v-else style="color: #42a5f5" @click="download(scope.row)">{{ scope.row.infoName }}</div> -->
                <!-- </template> -->
            </el-table-column>
            <el-table-column prop="projectCode" label="项目编号" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.projectCode }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="projectAmount" label="项目金额（元）" align="center" width="150px">
                <!-- <template slot-scope="scope">
                    <div v-if="canEdit">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="项目金额（元）" :rules="feeAmountRules">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-input v-model="scope.row.projectAmount" v-can-edit :can-edit="canEdit" placeholder="请输入" name="projectAmount" @input="validateInput(scope.row.projectAmount, scope)" />
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                    <div v-else>{{ scope.row.projectAmount }}</div>
                </template> -->
            </el-table-column>
            <el-table-column prop="winBidAmount" label="中标金额" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.winBidAmount }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <div v-if="baseModule === 'zljysq'">
                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" :rules="feeDescRules" name="类型">
                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                    <el-select v-model="scope.row.type" placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-tooltip>
                            </ValidationProvider>
                        </div>
                        <div v-else>{{ borrowTypeFormatter(scope.row.type) }}</div>
                    </div>
                    <div v-else>{{ borrowTypeFormatter(scope.row.type) }}</div>
                </template>
            </el-table-column>
            <el-table-column v-if="baseModule === 'zljysq'" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link v-if="canEdit" type="primary" @click="delClick(scope.row)">删除</el-link>
                    <el-link v-else type="primary" @click="downData(scope.row)">下载</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog class="dialogStyle" title="选择资料" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div class="content">
                <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
                    <el-tab-pane name="jggd">
                        <span slot="label">招标业绩资料</span>
                        <dataListJggd v-if="activeTab === 'jggd'" :vo="vo" :can-edit="canEdit"></dataListJggd>
                    </el-tab-pane>
                    <el-tab-pane name="2023-2024年招标业绩">
                        <span slot="label">2023-2024年招标业绩</span>
                        <dataListJggd v-if="activeTab === '2023-2024年招标业绩'" :vo="vo" :can-edit="canEdit" :active-tab="activeTab" :old-data-type="'2023-2024年招标代理业绩明细汇总表'"></dataListJggd>
                    </el-tab-pane>
                    <el-tab-pane name="2022年招标业绩">
                        <span slot="label">2022年招标业绩</span>
                        <dataListJggd v-if="activeTab === '2022年招标业绩'" :vo="vo" :can-edit="canEdit" :active-tab="activeTab" :old-data-type="'2022年招标业绩汇总表'"></dataListJggd>
                    </el-tab-pane>
                    <el-tab-pane name="2021年招标业绩">
                        <span slot="label">2021年招标业绩</span>
                        <dataListJggd v-if="activeTab === '2021年招标业绩'" :vo="vo" :can-edit="canEdit" :active-tab="activeTab" :old-data-type="'2021年招标明细汇总表'"></dataListJggd>
                    </el-tab-pane>
                    <el-tab-pane name="2020年招标业绩">
                        <span slot="label">2020年招标业绩</span>
                        <dataListJggd v-if="activeTab === '2020年招标业绩'" :vo="vo" :can-edit="canEdit" :active-tab="activeTab" :old-data-type="'2020年招标业绩汇总表'"></dataListJggd>
                    </el-tab-pane>
                    <el-tab-pane name="zjxmJggd">
                        <span slot="label">造价业绩资料</span>
                        <dataListZjxmJggd v-if="activeTab === 'zjxmJggd'" :vo="vo" :can-edit="canEdit"></dataListZjxmJggd>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const { uuid } = require('@/global/utils/index.js')
import dataListJggd from './dataListJggd'
import dataListZjxmJggd from './dataListZjxmJggd'
import moment from 'moment'
export default {
    components: { dataListJggd, dataListZjxmJggd },
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        baseModule: { type: String, default: null },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }

        // 自定义属性
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        const feeDescRules = {
            required: true
        }
        const occureDateRules = {
            required: true
        }
        const feeAmountRules = {
            required: true
        }

        const handleFeeAmountInput = (value) => {
            // 这里可以添加对费用金额的其他校验逻辑
        }

        // 如果需要，可以在这里添加对ValidationProvider实例的引用逻辑
        // 例如：
        // const { validate } = useValidation();
        // ...

        return {
            feeTypeRules,
            feeAmountRules,
            handleFeeAmountInput,
            feeDescRules,
            occureDateRules
            // ... 其他响应式引用
        }
    },
    data() {
        return {
            moduleInfo: {},
            loginUser: this.$store.getters.loginUser,
            listData: [],
            wfInstance: {},
            options: [
                {
                    value: '电子版',
                    label: '电子版'
                },
                {
                    value: '纸质版',
                    label: '纸质版'
                }
            ],
            dialogVisible: false,
            selectedRows: [],
            pageType: '',
            activeTab: 'jggd'
        }
    },
    computed: {},
    watch: {
        listData: {
            handler(newVal, oldVal) {
                // 当listData发生变化时，更新vo.passenger[listName]
                this.vo.passenger[this.listName] = newVal
            },
            deep: true
        }
    },
    created() {
        this.$bus.on('wfInstance', this.getWfInstance)
        this.$bus.on('selectRow', this.selectRow)
    },
    beforeDestroy() {
        this.$bus.off('wfInstance', this.getWfInstance)
        this.$bus.on('selectRow', this.selectRow)
    },
    mounted() {
        this.moduleInfo = {
            delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
            addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
            insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
            moduleCode: this.module,
            updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
            listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
            getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
            querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        }
        this.getListData()
    },
    updated() {},
    methods: {
        downData(row) {
            window.open('apigw/dagl/xmzlFile/downloadMaterialsByBusiDataId?busiDataId=' + row.busiDataId)
        },
        handleClick(tab, event) {},
        borrowTypeFormatter(val) {
            var str = ''
            switch (val) {
                case '电子版':
                    str = '电子版'
                    break
                case '纸质版':
                    str = '纸质版'
                    break
            }
            return str
        },
        async getListData(model) {
            if (this.isHttp) {
                const data = {
                    pageNum: 1,
                    pageSize: 999,
                    urlsearch: `formId:${this.vo.id}`
                }
                const res = await this.$app.listdata(this.moduleInfo.listDataUrl, data)
                console.log(res, 'res')

                if (res.code === 'success') {
                    this.listData = res.body.listdata
                }
            } else if (this.listName) {
                if (this.vo.passenger && this.vo.passenger[this.listName] && this.vo.passenger[this.listName].length > 0) {
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (!item.formId) {
                            item.formId = this.vo.id
                        }
                        if (!item.id) {
                            item.id = uuid()
                        }
                        if (!item.creatorId) {
                            item.creatorId = this.loginUser.id
                        }
                        if (!item.createTime) {
                            // 获取当前时间
                            const now = moment()
                            // 格式化当前时间
                            const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                            item.createTime = formattedNow
                        }
                    })
                    this.listData = this.vo.passenger[this.listName]
                }
            } else {
                console.log('请传递listName参数或改用接口获取数据')
            }
        },
        cellclick(row) {
            console.log(row, 'row')
            if (row.projectType === '造价') {
                console.log(row, 'row')
                this.$http({
                    url: 'zjgl/zjxmArch/listdata',
                    method: 'post',
                    params: {
                        urlsearch: 'projectCode:' + row.projectCode
                    },
                    contentType: 'application/x-www-form-urlencoded'
                }).then((res) => {
                    const linkrow = res.body.pageInfo.list[0]
                    window.open('#/zjtzView?wfEngineUrl=zjgl/zjxmArch&busiDataId=' + linkrow.id + '&logoTitle=' + encodeURIComponent('造价管理/' + linkrow.flSubject) + '&type=' + 'attachment' + '&canEdit=' + (this.vo.status === 2 ? '1' : '0'))
                })
            } else {
                console.log(row, 'row')
                this.$http({
                    url: 'zbgl/zbxmArch/listdata',
                    method: 'post',
                    params: {
                        urlsearch: 'projectCode:' + row.projectCode
                    },
                    contentType: 'application/x-www-form-urlencoded'
                }).then((res) => {
                    const linkrow = res.body.pageInfo.list[0]
                    window.open('#/zbtzView?wfEngineUrl=zbgl/zbxmArch&busiDataId=' + linkrow.id + '&logoTitle=' + encodeURIComponent('招标管理/' + linkrow.flSubject) + '&type=' + 'attachment' + '&canEdit=' + (this.vo.status === 2 ? '1' : '0'))
                })
            }
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            const index = this.listData.findIndex((item) => item.id === row.id)
            if (index !== -1) {
                // 使用splice方法删除该项
                this.listData.splice(index, 1)
            } else {
                console.error('未找到要删除的数据项')
            }
        },
        getWfInstance(val) {
            this.wfInstance = val
        },
        xbzbYjzlAdd() {
            if (this.wfInstance.id) {
                this.dialogVisible = true
                this.pageType = 'innerDialog'
            } else {
                this.$parent.$vnode.context.btnSubmitClick('AutoSave', (saveRst, a, b, c) => {
                    if (saveRst) {
                        this.dialogVisible = true
                        this.pageType = 'innerDialog'
                    }
                })
            }
        },
        selectRow(rowData) {
            this.selectedRows = rowData
        },
        sureBtn() {
            console.log('🚀 ~ selectRow ~ this.selectedRows:', this.selectedRows)
            let arr = []
            let arrItem = {}
            this.selectedRows.forEach((item) => {
                debugger
                arrItem = {
                    projectName: item.flSubject,
                    // projectId: item.projectName,
                    projectCode: item.projectCode,
                    projectAmount: item.xmAmount,
                    winBidAmount: item.cjAmount,
                    formId: this.vo.id,
                    busiDataId: item.id,
                    type: '电子版',
                    projectType: this.activeTab === 'jggd' ? '招标' : '造价'
                }
                arr.push(arrItem)
            })
            this.dialogVisible = false
            this.listData.push(...arr)
            // 然后进行去重处理
            const seen = new Set()
            this.listData = this.listData.filter((item) => {
                if (seen.has(item.busiDataId)) {
                    return false
                }
                seen.add(item.busiDataId)
                return true
            })

            this.selectedRows = []
        },
        xbzbYjzlExport() {
            if (this.listData.length === 0) {
                this.$alert('暂无数据导出', '提示', {
                    confirmButtonText: '确定'
                })
                return
            } else {
                window.open(`/apigw/tbgl/zljysqXmyjzlItem/exportCustomData?formId=${this.vo.id}`)
            }
        },
        // 监听input，处理数字
        validateInput(value, scope) {
            value = value.replace(/[^\d.]/g, '') // 只保留数字和小数点
            value = value.replace(/^\./, '') // 去掉开头的小数点
            value = value.replace(/\.{2,}/g, '.') // 去掉多余的小数点
            value = value.replace(/^0+(\d)/, '$1') // 去掉开头的多余零
            value = value.replace(/^(\d+\.\d\d)\d+$/, '$1') // 限制只能输入两位小数
            this.$set(this.listData[scope.$index], scope.column.property, value)
        },
        download(attach) {
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/tbgl/zljysq/downloadById?inline=false&attachIds=' + attach.passenger.attachments[0].id)
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table .el-link--inner {
    width: 100%;
}
.mx_content /deep/ .el-table__body-wrapper tr td:last-child {
    border-right-color: #e2e7ed !important;
}
.mx_content {
    .mx_title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #999;
        justify-content: space-between;
        background: #ffffff;
        padding: 0 10px;
    }
}

.attachment-link-wrapper {
    display: flex;
    align-items: center;
    /* 如果需要垂直居中 */
    justify-content: space-between;
    /* 确保链接和按钮之间有间隔，并分别位于开始和结束位置 */
    .el-lint-inner {
        width: 100%;
    }
}

.attachment-link {
    flex: 1;
    /* 占据可用空间，但不会挤压删除按钮 */
    overflow: hidden;
    /* 隐藏超出容器的部分 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    /* 其他你需要的样式 */
}

.remove-button {
    /* 确保按钮始终可见，并位于行尾 */
    /* 你可以添加更多的样式来美化按钮 */
}
/deep/.el-dialog__header {
    height: 54px;
}
/deep/.el-dialog__wrapper .el-dialog__title::before {
    top: 15.5px;
}
/deep/.el-textarea__inner {
    min-height: 70px !important;
    height: 70px !important;
}
.dialogStyle {
    margin-top: -5vh;
    .zlcxIndex {
        height: 600px;
        /deep/.panel-left {
            height: 100%;
        }
    }

    .content {
        margin-top: 20px;
    }
}
</style>
